import axios from 'axios'

const courseware = {}
// 删除课件
courseware.del = params => { return axios.get('/video/cw/del', {params}) }
// 加载课件
courseware.load = params => { return axios.get('/video/cw/load', {params}) }
// 上传课件
courseware.save = params => { return axios.post('/video/cw/save', params) }
// 查询课件
courseware.find = params => { return axios.get('/video/cw/finds', {params}) }
// 删除课件视频
courseware.delByVideoId = params => { return axios.get('/video/delVideo', {params}) }
// 课件视频  根据ID 手动转码
courseware.manualTranscoding = params => { return axios.get('/video/manualTranscoding', {params}) }

// 课件排序
courseware.move = params => { return axios.post('/video/cw/move', params) }

// 查询所有视频分类 不分页
courseware.findAllType = params => { return axios.post('/video/videoType/findAll', params) }
// 查询所有视频分类 分页
courseware.findType = params => { return axios.post('/video/videoType/find', params) }
// 添加、修改视频分类
courseware.updateType = params => { return axios.post('/video/videoType/update', params) }
// 删除视频分类
courseware.dels = params => { return axios.get('/video/videoType/dels', {params}) }
// 删除视频分类
courseware.loadType = params => { return axios.get('/video/videoType/load', {params}) }
export default courseware



// WEBPACK FOOTER //
// ./src/api/courseware.js